import { Button, MyTableComponent } from "components"
import { Box } from "theme-ui"
import { useTranslation } from "react-i18next"

export const MessageReceipt = () => {
 // language translator
 const { t } = useTranslation("translation")
 const data = [
  {
   info1: "Schwere Fehler",
   info2: "1 Meldungen",
   info3: "Test Server",
  },
  {
   info1: "Schwere Fehler",
   info2: "1 Meldungen",
   info3: "Test Server",
  },
  {
   info1: "Schwere Fehler",
   info2: "1 Meldungen",
   info3: "Test Server",
  },
  {
   info1: "Schwere Fehler",
   info2: "1 Meldungen",
   info3: "Test Server",
  },
  {
   info1: "Schwere Fehler",
   info2: "1 Meldungen",
   info3: "Test Server",
  },

  {
   info1: "Schwere Fehler",
   info2: "1 Meldungen",
   info3: "Test Server",
  },
  {
   info1: "Schwere Fehler",
   info2: "1 Meldungen",
   info3: "Test Server",
  },
  {
   info1: "Schwere Fehler",
   info2: "1 Meldungen",
   info3: "Test Server",
  },
 ]

 const columns = [
  { Header: "Name", accessor: "info1" },
  { Header: t("investments"), accessor: "info2" },
  { Header: t("headQuarters"), accessor: "info3" },
  {
   Header: t("action"),
   Cell: () => (
    <div className="flex justify-end">
     <div className="mr-2">
      <Button size={"tableSmallSize"} color={"darkBrown"}>
       {" "}
       {t("edit")}
      </Button>
     </div>
     <div className="mr-2">
      <Button size={"tableSmallSize"} color={"pink"}>
       {" "}
       {t("delete")}
      </Button>
     </div>
    </div>
   ),
  },
 ]

 return (
  <div className="w-full lg:w-[96%] mx-auto relative h-screen  md:h-screen lg:h-full pt-5">
   <div className="flex justify-between items-center mb-4">
    <h1 className="Jakarta-font font-bold text-xl">{t("editMessageRecipients")}</h1>
    <div className="flex">
     <div>
      <Button size={"doublexl"}>Forum Gera</Button>
     </div>
    </div>
   </div>
   <Box bg="highlight" color="text-black">
    <div className="py-3 px-3">
     <Box bg="highlight" className="flex justify-between items-center py-4 px-2">
      <h1 className="Jakarta-font font-semibold text-lg">{t("messageRecipient")}</h1>
      <div className="flex">
       <Button size={"xl"}>{t("add")}</Button>
      </div>
     </Box>
    </div>
   </Box>

   {/* ====== TableComponent ====== */}
   <MyTableComponent fullHeight={true} columns={columns} data={data} paginate={false} />
  </div>
 )
}
